import settings from './settings/settings.routes';
import { userNotificationRoutes } from './settings/profile/profile.routes';
import billing from './settings/billing/billing.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL, organizationURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import calendarRoutes from './calendar/calendar.routes';
import workflowsRoutes from './workflows/workflows.routes';
import aiAgents from './aiAgents/aiAgents.routes';
import onboarding from './onboarding/onboarding.routes';
const AppContainer = () => import('./Dashboard.vue');
const Suspended = () => import('./suspended/Index.vue');
const NoAccounts = () => import('./noAccounts/Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...inboxRoutes,
        ...conversation.routes,
        ...workflowsRoutes.routes,
        ...aiAgents.routes,
        ...onboarding.routes,
        ...billing.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...calendarRoutes.routes,
      ],
    },
    {
      path: organizationURL(':organizationId'),
      component: AppContainer,
      children: billing.organizationRoutes,
    },
    {
      path: '/user',
      component: AppContainer,
      children: userNotificationRoutes,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
